(function() {
    var InvoiceItemSelect = function ($el) {
        this.$el = $el

        this.$el.on('change', this.valueChange.bind(this))

        this.init()

        return this
    }

    InvoiceItemSelect.prototype.isMisc = function () {
        if (!this.doesSelectedMatchOption()) {
            return true
        }

        return this.$el.val() == "Miscellaneous"
    }

    InvoiceItemSelect.prototype.doesSelectedMatchOption = function () {
        var selected = this.$el.data('oldSelected')

        if (_.isEmpty(selected)) {
            true
        }

        return this.$el.find('option[value="' + selected + '"]').length > 0
    }

    InvoiceItemSelect.prototype.changeToInput = function () {
        var $input = $('<input>')
            .attr('type', 'text')
            .attr('class', 'form-control')
            .attr('placeholder', 'Please select a description')
            .attr('name', this.$el.attr('name'))

        if (!this.doesSelectedMatchOption()) {
            $input.attr('value', this.$el.data('oldSelected'))
        }

        this.$el.replaceWith($input)

        $input.focus()

        return this
    }

    InvoiceItemSelect.prototype.setDropdownSelected = function () {
        this.$el.val(this.$el.data('oldSelected'))
    }

    InvoiceItemSelect.prototype.init = function () {
        if (this.isMisc()) {
            this.changeToInput()
        } else {
            this.setDropdownSelected()
        }

        this.$el.trigger('init', [this.$el])

        this.$el.focus()
        
        return this
    }

    InvoiceItemSelect.prototype.valueChange = function () {
        if (this.isMisc()) {
            this.$el.trigger('is-misc', [this.$el])

            this.changeToInput()
        } else {
            this.$el.trigger('value-changed', [this.$el])
        }

        return this
    }

    var observer = document.getElementById('invoice-item-observer')

    if (observer) {
        $.initialize('.invoice-item-select', function() {
            new InvoiceItemSelect($(this))
        }, { target: observer })
    }
})()
